<template>
    <header id="navbar" role="banner" class="navbar container navbar-default">
        <div class="navbar-header row">
            <div class="col-lg-2 col-md-2 col-xs-3">
                <a class="logo navbar-btn pull-left" href="http://www.ge.ch/"
                   title="ge.ch" target="_blank">R&eacute;publique et canton de Gen&egrave;ve</a>
            </div>
            <div class="lead col-lg-8 col-md-8 col-xs-8">
                <span>R&eacute;publique et canton de Gen&egrave;ve</span>
            </div>
            <div class="col-lg-2 col-md-2 col-xs-1">
                <a href="#" class="e_demarche pull-right" id="menu-toggle"></a>
            </div>
        </div>
    </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String,
  },
};

</script>
